import { Box, Divider, Grid, Typography, styled, useTheme } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";

function RequestHistoryBox({ item }) {
  const theme = useTheme()

  return (
    <HistoryBoxWrapper>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.main">
            {item?.side}
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <CoinWrapper>
            <img src={DefaultUrlWeb + item?.coinImageUrl} alt="" />

            <Box>
              <Typography color="text.main" variant="h6" component="span">
                {item?.coinName}
              </Typography>
            </Box>
          </CoinWrapper>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle1">
            Amount
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h5">
            <NumberFormats value={item?.amount || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <Grid container mt={1} spacing={1}>
        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            State
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.main"
              fontWeight={400}
            >
              {item?.state}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Fee
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.fee || 0} />{" "}

            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Side
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.main"
              fontWeight={400}
            >
              {item?.side}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Date/Time Edit
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.main"
              fontWeight={400}
            >
              {item?.dateEdit}{" "}{item?.timeEdit}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Date/Time
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.main"
              fontWeight={400}
            >
              {item?.date}{" "}{item?.time}
            </Typography>
          </Typography>
        </Grid>



        <Grid item xs={12}>
          <Divider color={theme.palette.text.secondary} />
        </Grid>

        <Grid item xs={12}>
          <Typography color="text.secondary" fontWeight={500} variant="subtitle1">
            Comment: {" "}

            <Typography
              component="span"
              color="text.main"
              fontWeight={400}
              variant="subtitle1"
            >
              {item?.comment || "-"}
            </Typography>
          </Typography>

        </Grid>
      </Grid>
    </HistoryBoxWrapper>
  );
}

const HistoryBoxWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  borderRadius: "8px",
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const CoinWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  img: {
    marginRight: theme.spacing(1),
    width: "27px",
    height: "27px",
  },
}));

export default RequestHistoryBox;
